<template>
    <a
        v-if="member.conflictOfInterests && member.conflictOfInterests.length"
        href="#"
        @click.prevent="emit('click')"
    >
        Conflict of interest
    </a>
    <em v-else-if="showEmptyDeclaration">
        No conflict of interest to declare
    </em>
</template>

<script setup>
defineProps({
    member: {
        type: Object,
        required: true
    },
    showEmptyDeclaration: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['click']);
</script>
